var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIconConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-10.043-12.706a7.068,7.068,0,0,0-1.829-1.323.606.606,0,0,0-.7.116l-.222.222a2.626,2.626,0,0,0-.752,1.544.611.611,0,0,0,.333.627,4.239,4.239,0,0,1,1.159.824,4.271,4.271,0,0,1,0,6.032L-15.873-.844a4.264,4.264,0,0,1-6.033,0,4.264,4.264,0,0,1,0-6.033l2.328-2.328a.606.606,0,0,0,.163-.569,8.786,8.786,0,0,1-.241-1.921.609.609,0,0,0-1.04-.416c-.588.587-1.556,1.558-3.22,3.222a7.1,7.1,0,0,0,0,10.054,7.105,7.105,0,0,0,10.054,0c4.172-4.172,4-3.976,4.313-4.368A7.119,7.119,0,0,0-10.043-12.706Zm7.959-7.959a7.105,7.105,0,0,0-10.054,0c-4.172,4.172-4,3.976-4.313,4.368a7.119,7.119,0,0,0,.5,9.5,7.068,7.068,0,0,0,1.829,1.323.606.606,0,0,0,.7-.116l.222-.222a2.626,2.626,0,0,0,.752-1.544.611.611,0,0,0-.333-.627A4.238,4.238,0,0,1-13.946-8.8a4.271,4.271,0,0,1,0-6.032l3.818-3.819a4.264,4.264,0,0,1,6.033,0,4.264,4.264,0,0,1,0,6.033l-2.328,2.328a.606.606,0,0,0-.163.569,8.786,8.786,0,0,1,.241,1.921.609.609,0,0,0,1.04.416c.588-.587,1.556-1.558,3.22-3.222A7.1,7.1,0,0,0-2.084-20.666Z",
    transform: "translate(26 22.75)",
    fill: "#3a3630",
    opacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconConnected);
export default __webpack_public_path__ + "static/media/settingsIcon_Connected.7a32ac64.svg";
export { ForwardRef as ReactComponent };